// ENTITIES
import { RequestPesquisarRg } from 'pages/iirgd/RgFicDigital/PesquisaRg/Formulario/form';

// TYPES
import { ReducerActionRotaSP } from 'store/modules/types';
import { Types } from './types';

export function consultarCinPPTRequest(
	data: RequestPesquisarRg,
): ReducerActionRotaSP {
	return {
		type: Types.CONSULTAR_CIN_PPT_REQUEST,
		payload: {
			data,
		},
	};
}
export function consultarCinPPTSuccess(payload: object): ReducerActionRotaSP {
	return {
		type: Types.CONSULTAR_CIN_PPT_SUCCESS,
		payload,
	};
}
export function consultarCinPPTFailure(payload: object): ReducerActionRotaSP {
	return {
		type: Types.CONSULTAR_CIN_PPT_FAILURE,
		payload,
	};
}
export function consultarCinPPTClear(): ReducerActionRotaSP {
	return {
		type: Types.CONSULTAR_CIN_PPT_CLEAR,
		payload: null,
	};
}
